export const ShopInfo = {
  restaurantId: "69269f5c104f4f708262db53",
GST_RATE: 0.05,

  en: {
    // Name: "FinGlider Menu System",
    Name: "Kairali Adukkala",
    // Address:
    //   "Novel Tech Park, 1st Floor, Near Manyata Embassy Business Park, Nagavara, Bangalore-560045",
    Address:"Ground Floor, Essel Willcon Building, Father Muller's Rd, Bendoorwell, Bendoor, Mangaluru, Karnataka 575002",
    Phone: "+91 9141151515",
    Whatsapp: "+919141151515",
    WhatsappMessageHeader: "Hello. Please find the below order.",
    OpenTime: "08:30 AM",
    CloseTime: "11:00 PM",
    CartEmptyMessage: "Your cart is empty now. Add items to place order."
  },

  ar: {
    // Name: "نظام قائمة فن جلايدر",
    Name: "كيرالي أدوكالا",
    // Address:
    //   "منتزه نوفل التقني، الطابق الأول، بالقرب من مجمع مانياتا للأعمال، ناغافارا، بنغالور - 560045",
    Address:"الطابق الأرضي، مبنى إيسيل ويلكون، طريق الأب مولر، بيندورويل، بيندور، مانجالورو، كارناتاكا 575002",
    Phone: "+91 9141151515",
    Whatsapp: "+919141151515",
    WhatsappMessageHeader: "مرحباً، يرجى الاطلاع على الطلب أدناه.",
    OpenTime: "08:30 ص",
    CloseTime: "11:00 م",
    CartEmptyMessage: "سلة التسوق فارغة حالياً. أضف عناصر لإتمام الطلب."
  }
};
